import React, { ReactElement } from 'react';
import Image from '../image/image.component';
import MenuItem from '../menu-item/menu-item.component';
import MenuItemContent from '../menu-item-content/menu-item-content.component';
import TextBlock from '../text-block/text-block.component';
import TextBold from '../text-bold/text-bold.component';
import CheckedIcon from '../../icons/checked-icon';
import NoImage from '../../static/images/no-image.png';

const MenuItemList: ReactComponentList = (props: ReactComponentProps): ReactElement[] => {
  const VALUE_KEY_DEFAULT: string = 'id';
  const LABEL_KEY_DEFAULT: string = 'title';
  const IMAGE_KEY_DEFAULT: string = 'photo';
  const IMAGE_THUMBNAIL_KEY_DEFAULT: string = 'photoThumbnail';

  const {
    isExtended,
    isGrouped,
    withImage,
    withPermissions,
    withNoWrapItems,
    withMenuItemOffset,
    iconMap,
    groupKey,
    groupItemLabelKey,
    optionItemLabelKey,
    optionItemExtraLabelKey,
    optionItemDetailsLabelKey,
    optionItemValueKey,
    optionItemImageKey,
    optionItemImageThumbnailKey,
    labelCallback,
    selectedValue,
    defaultImage,
    optionList,
    selectedItemList,
    onClick,
    onChange,
  } = props;

  const valueKey: string = optionItemValueKey || VALUE_KEY_DEFAULT;
  const labelKey: string = optionItemLabelKey || LABEL_KEY_DEFAULT;
  const imageKey: string = optionItemImageKey || IMAGE_KEY_DEFAULT;
  const imageThumbnailKey: string = optionItemImageThumbnailKey || IMAGE_THUMBNAIL_KEY_DEFAULT;

  if (!optionList || (optionList && !optionList.length)) {
    return [];
  }

  return (
    optionList.map((optionItem: SelectItem): ReactElement => {
      const isSelected: boolean = (selectedItemList && !!selectedItemList.length
        && !!selectedItemList.find((selectedOptionItem: SelectItem): boolean => (
          selectedOptionItem[valueKey] === optionItem[valueKey]
        ))) || (selectedValue && selectedValue === optionItem[valueKey]);
      const optionItemExtraLabel: string = optionItemExtraLabelKey && optionItem[optionItemExtraLabelKey]
        ? ` <${optionItem[optionItemExtraLabelKey]}>` : '';
      const optionItemDetailsLabel: string = optionItemDetailsLabelKey && optionItem[optionItemDetailsLabelKey]
        ? ` (${optionItem[optionItemDetailsLabelKey]})` : '';
      const label: string = labelCallback ? labelCallback(optionItem) : null;

      return (
        <MenuItem
          isActive={isSelected}
          withNoWrap={withNoWrapItems}
          withOffset={withMenuItemOffset}
          key={optionItem.id}
          value={optionItem[valueKey]}
          permission={withPermissions && optionItem.permission ? optionItem.permission : null}
          onClick={onClick ? ((event: React.MouseEvent<Element, MouseEvent>): void => {
            onClick(event, optionItem);
          }) : null}
          onChange={onChange ? ((event: React.ChangeEvent): void => {
            onChange(event, optionItem);
          }) : null}
        >
          {
            isGrouped && (
              groupKey && groupItemLabelKey && optionItem[groupKey] ? (
                <TextBlock>
                  <TextBold>
                    {optionItem[groupKey][groupItemLabelKey]}
                  </TextBold>
                  :
                  {' '}
                  {optionItem[labelKey]}
                </TextBlock>
              ) : optionItem[labelKey]
            )
          }
          {
            !isGrouped && (
              isExtended ? (
                <MenuItemContent
                  withImage={withImage}
                  withIcon={!!iconMap && !!optionItem[valueKey] && !!iconMap[optionItem[valueKey]]}
                >
                  {
                    !!iconMap && !!optionItem[valueKey] && iconMap[optionItem[valueKey]]
                  }
                  <TextBlock>
                    {`${label || optionItem[labelKey]}${optionItemExtraLabel}${optionItemDetailsLabel}`}
                  </TextBlock>
                  {
                    !iconMap && (
                      <Image
                        isDefault
                        text={optionItem[labelKey]}
                        link={optionItem[imageThumbnailKey] || optionItem[imageKey] || defaultImage || NoImage}
                      />
                    )
                  }
                </MenuItemContent>
              ) : (`${label || optionItem[labelKey]}${optionItemExtraLabel}${optionItemDetailsLabel}`)
            )
          }
          {
            isSelected && selectedItemList && !!selectedItemList.length && (
              <CheckedIcon />
            )
          }
        </MenuItem>
      );
    })
  );
};

export default MenuItemList;
